import type { ISector } from '__generated__';
import { baseApi, sectorActiveTag } from 'store/api';
import { APIRead, getAllDynamic, normalizeError } from 'utils/api-client';

export const sectorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getActiveSectors: builder.query<ISector[], void>({
      async queryFn() {
        try {
          const { value } = await getAllDynamic<ISector>(
            (body) => APIRead.api.sectorGetAllDynamicCreate(body),
            {
              filter: 'isActive==true',
              orderBy: 'title asc',
            },
          );

          return { data: value };
        } catch (error) {
          return { error: normalizeError(error) };
        }
      },
      providesTags: [sectorActiveTag],
    }),
  }),
});

export const { useGetActiveSectorsQuery, useLazyGetActiveSectorsQuery } = sectorApi;
